/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'

// Libraries
import parse from 'html-react-parser'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import Requirements from 'components/Requirements'
import ParseContent from 'components/shared/ParseContent'
import Review from 'components/Review'
import Sirelo from 'components/Sirelo'
import PriceIndication from 'components/PriceIndication'
import Blog from 'components/Blog'
import Tabs from 'components/Tabs'
import MobileTabs from 'components/MobileTabs'
import RatingAlt from 'components/Reviews/RatingAlt'
import Plaatjie from "@ubo/plaatjie"

// Elements
import HeroDefault from 'components/elements/HeroDefault'
import ImageBackground from 'components/elements/ImageBackground'
import HeroDescription from 'components/elements/HeroDescription'
import BlockDefault from 'components/elements/BlockDefault'
import ButtonDefault from 'components/elements/ButtonDefault'
import ButtonSecondary from 'components/elements/ButtonSecondary'
import BackgroundDescription from 'components/elements/BackgroundDescription'
import ButtonAlt from 'components/elements/ButtonAlt'

// Data
import blogInfo from 'src/graphql/blogInfo'
import Infographic from '../components/Infopgrahic/Infographic'

const Intro = styled(BlockDefault)`
  @media (min-width: 992px) {
    margin-top: -150px;

    & h2 {
      font-size: ${(props) => props.theme.font.size.xl};
      font-weight: ${(props) => props.theme.font.weight.s};

      & strong {
        font-weight: ${(props) => props.theme.font.weight.xl};
      }
    }
  }

  @media (max-width: 991px) {
    margin-top: -100px;
  }
`

const FeaturedImage = styled(ImageBackground)`
  padding-top: 50%;
  border-radius: 35px;
  overflow: hidden;
`

const Block = styled(BlockDefault)`
  @media (min-width: 992px) {
    margin-top: -200px;
  }

  @media (max-width: 991px) {
    margin-top: -50px;
  }

  @media (max-width: 575px) {
    margin-top: -35px;
  }
`

const Content = styled(ParseContent)`
  & h1,
  & h2,
  & h3,
  & h4,
  & h5 {
    color: ${(props) => props.theme.color.text.contrast};
  }
`

const HeroBlock = styled(BlockDefault)`
  & h1 {
    font-size: ${(props) => props.theme.font.size['50']};
    line-height: 50px;
    color: ${(props) => props.theme.color.text.contrast};
    text-shadow: none;
  }

  & p {
    color: ${(props) => props.theme.color.text.main};
  }

  & span {
    color: ${(props) => props.theme.color.text.main};
    display: block;
  }

  margin-top: 200px;
`

const HeroTitle = styled(ParseContent)`
  @media (max-width: 991px) {
    & h1 {
      font-size: ${(props) => props.theme.font.size['35']};
      line-height: 40px;
    }
  }
`

const CTA = styled(ParseContent)``

const ButtonSecond = styled(ButtonSecondary)`
  width: 295px;
  text-align: left;

  & a {
    font-size: ${(props) => props.theme.font.size['18']};
  }
`

const ButtonFirst = styled(ButtonDefault)`
  width: 295px;

  & a {
    font-size: ${(props) => props.theme.font.size['18']};
  }
`

const ContentTitle = styled(ParseContent)`
  & h2 {
    font-size: ${(props) => props.theme.font.size['50']};
  }
`

export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      path
      title

      acf {
        banner {
          title
          description
          cta {
            title
            buttonOne: button_one {
              title
              url
            }
            buttonTwo: button_two {
              title
              url
            }
          }
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 1920)
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }

        intro {
          title
        }

        cities {
          title
          city {
            wordpress_id
          }
        }

        tabs {
          title
          tab_name
          description
          cta {
            title
            button {
              title
              url
            }
          }
        }

        terms {
          title
          usp {
            relation
          }
        }

        intro {
          background_description
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          description
        }

        review {
          title
          rating
          description
          background_description
        }

        outro {
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          description
        }

        blog {
          related
          background_description
        }

        show_infographic
      }

      yoast_meta {
        name
        content
        property
      }
    }
    nations: allWordpressPage(
      limit: 100
      filter: { parent_element: { wordpress_id: { in: [118, 133, 230, 225, 757, 752, 760] } } }
      sort: { fields: menu_order, order: ASC }
    ) {
      edges {
        node {
          wordpress_id
          title
          path
          wpml_current_locale
          acf {
            banner {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 400)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { path, yoast_meta: yoast, acf, title },
    nations: { edges: nationsEdges },
  },
}) => {

  React.useEffect(() => {
    const structuredDataId = 'nation-movingcompany-structured-data'
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'MovingCompany',
      name: 'Schmidt Global Relocations',
      url: 'https://www.schmidt-global.nl',
      logo: ' https://admin.schmidt-global.nl/wp-content/uploads/2021/05/Schmidt-logo-2019.png',
      telephone: '+31337600270',
      email: 'info@schmidt-global.nl',
      address: {
        '@type': 'PostalAddress',
        streetAddress: ' Stationsweg Oost 281 D',
        addressLocality: 'Woudenberg',
        addressRegion: 'Utrecht',
        postalCode: '3931 ER',
        addressCountry: 'NL',
      },
      openingHours: 'Mo-Fr 09:00-17:30',
      areaServed: [
        {
          '@type': 'Country',
          name: `${title}`,
        },
        {
          '@type': 'Country',
          name: 'Nederland',
        },
      ],
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.8',
        reviewCount: '732',
      },
      sameAs: [
        'https://www.facebook.com/schmidtglobal',
        'https://www.linkedin.com/company/schmidtglobal',
      ],
    }

    if (typeof window !== 'undefined') {
      let script = document.getElementById(structuredDataId)

      if (!script) {
        script = document.createElement('script')
        script.id = structuredDataId
        script.type = 'application/ld+json'
        document.head.appendChild(script)
      }

      script.textContent = JSON.stringify(structuredData)
    }
  }, [])

  React.useEffect(() => {
    const structuredDataId = 'nation-service-structured-data'
    const serviceStructuredData = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: `Internationaal verhuizen naar ${title}`,
      provider: {
        '@type': 'MovingCompany',
        name: 'Schmidt Global Relocations',
        url: 'https://www.schmidt-global.nl',
      },
      areaServed: [
        {
          '@type': 'Country',
          name: `${title}`,
        },
      ],
      description: `Complete verhuisservice van Nederland naar ${title} , inclusief inpakken, transport, douaneafhandeling en opslagmogelijkheden.`,
    }

    if (typeof window !== 'undefined') {
      let script = document.getElementById(structuredDataId)

      if (!script) {
        script = document.createElement('script')
        script.id = structuredDataId
        script.type = 'application/ld+json'
        document.head.appendChild(script)
      }

      script.textContent = JSON.stringify(serviceStructuredData)
    }
  }, [])

  React.useEffect(() => {
    const structuredDataId = 'nation-review-structured-data'
    const reviewDescription = (acf.review && acf.review.description) || ''
    let reviewAuthorName = ''
    let reviewBodyDescription = reviewDescription

    if (typeof window !== 'undefined') {
      const reviewContainer = document.createElement('div')
      reviewContainer.innerHTML = reviewDescription
      const reviewParagraphElements = reviewContainer.querySelectorAll('p')
      const reviewHeadingElements = reviewContainer.querySelectorAll('h3')

      const firstReviewHeading = reviewHeadingElements[0]
      if (firstReviewHeading && firstReviewHeading.textContent) {
        reviewBodyDescription = firstReviewHeading.textContent.trim()
      }

      if (reviewParagraphElements.length > 1) {
        const secondReviewParagraph = reviewParagraphElements[1]
        if (secondReviewParagraph && secondReviewParagraph.textContent) {
          reviewAuthorName = secondReviewParagraph.textContent.trim()
        }
      } else if (reviewParagraphElements.length === 1) {
        const firstReviewParagraph = reviewParagraphElements[0]
        if (firstReviewParagraph && firstReviewParagraph.textContent) {
          reviewAuthorName = firstReviewParagraph.textContent.trim()
        }
      }
    }

    const reviewStructuredData = {
      '@context': 'https://schema.org',
      '@type': 'Review',
      itemReviewed: {
        '@type': 'MovingCompany',
        name: 'Schmidt Global Relocations',
        url: 'https://www.schmidt-global.nl',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.8',
          reviewCount: '732',
        },
      },
      reviewBody: reviewBodyDescription,
      reviewRating: {
        '@type': 'Rating',
        ratingValue: (acf.review && acf.review.rating) || '5',
        bestRating: '5',
      },
      author: reviewAuthorName
        ? {
            '@type': 'Person',
            name: reviewAuthorName,
          }
        : {
            '@type': 'Organization',
            name: 'Schmidt Global Relocations',
          },
    }

    if (typeof window !== 'undefined') {
      let script = document.getElementById(structuredDataId)

      if (!script) {
        script = document.createElement('script')
        script.id = structuredDataId
        script.type = 'application/ld+json'
        document.head.appendChild(script)
      }

      script.textContent = JSON.stringify(reviewStructuredData)
    }
  }, [])

  const cityIds =
    acf &&
    acf.cities &&
    Array.isArray(acf.cities.city) &&
    acf.cities.city.length > 0
      ? acf.cities.city.map(({ wordpress_id: wordpressId }) => wordpressId)
      : []

  const otherCities = cityIds.length > 0
    ? nationsEdges.filter(({ node: { wordpress_id: wpId } }) => cityIds.includes(wpId))
    : []

  return (
    <Layout>
      <SEO
        yoast={yoast}
        path={path}
        image={{
          url:
            acf.banner.image.localFile &&
            acf.banner.image.localFile.childImageSharp.openGraph.src,
        }}
      />

      <section>
        <HeroDefault rounded image={acf.banner.image} big custom overflow>
          <HeroDescription className="d-flex align-items-center justify-content-start h-100">
            <HeroBlock bigBorderRadius className="col-lg-6">
              <HeroTitle content={acf.banner.title} className="mb-4" />
              <ParseContent content={acf.banner.description} className="mb-4" />
              <CTA content={acf.banner.cta.title} />
              <div className="px-lg-5 d-flex flex-wrap justify-content-center text-center">
                <div>
                  <ButtonFirst type="next" to={acf.banner.cta.buttonOne.url}>
                    {acf.banner.cta.buttonOne.title}
                  </ButtonFirst>
                  <span className="my-2">of</span>
                </div>
                <ButtonSecond to={acf.banner.cta.buttonTwo.url}>
                  {acf.banner.cta.buttonTwo.title}
                </ButtonSecond>
              </div>
            </HeroBlock>
          </HeroDescription>
        </HeroDefault>
      </section>

      <section id="tabInfo" className="pt-5">
        <div className="container py-5 ">
          <div className="row pt-5 pb-0 pb-lg-5 mt-5 mt-lg-0">
            <div className="col-12 d-flex justify-content-end px-lg-0">
              <ContentTitle content={acf.intro.title} />
            </div>
          </div>
          <Tabs className="d-none d-lg-flex" fields={acf.tabs} />
          <MobileTabs className="d-lg-none" content={acf.tabs} />
        </div>
      </section>

      {acf.cities && Array.isArray(acf.cities.city) && acf.cities.city.length > 0 && (
        <section className='mt-5'>
          <div className='mt-5 pt-5 container '>
            <div className='mt-5 pt-5 pt-lg-0'>
            {acf.cities.title && (
              <BackgroundDescription
                content={acf.cities.title}
                relative
              />
            )}
            <div className='d-flex flex-wrap flex-lg-nowrap'>
              {otherCities.map(({ node }) => (
                <Nation
                  key={node.wordpress_id}
                  title={node.title.replace('Verhuizen naar ', '')}
                  path={node.path}
                  image={node.acf.banner.image}
                />
              ))}
            </div>
            </div>
          </div>
        </section>
      )}

      <section>
        <div className="container mt-5 py-5">
          <div>{parse(acf.terms.title)}</div>
          <div className="mt-5">
            <Requirements ids={acf.terms.usp.map(({ relation }) => relation)} />
          </div>
        </div>
      </section>

      {acf.review && acf.review.title && (
        <section className="pt-5">
          <div className="container">
            <div className="row flex-wrap-reverse">
              <div className="col-lg-8">
                <BackgroundDescription
                  className="mt-3"
                  content={acf.review.background_description}
                  relative
                />
              </div>
              <div className="col-lg-4">
                <PriceIndication noInfo />
              </div>
            </div>
          </div>
          <Review fields={acf.review} />
        </section>
      )}

      <section>
        <div className="container mb-lg-5 py-5">
          <div className="row">
            <div className="col-lg-7" />
            <div className="col-lg-5">
              <RatingAlt noTitle className="pb-lg-0 pb-4" />
              <div className="mt-4">
                <PriceIndication />
              </div>
            </div>
          </div>
        </div>
      </section>

      {acf.show_infographic && <Infographic />}

      {acf.blog && acf.blog.related && acf.blog.related.length > 0 && (
        <section>
          <div
            className={`${
              acf.show_infographic && 'mt-lg-5 pt-lg-5'
            } container mb-lg-5 pb-5`}
          >
            {acf.blog.background_description && (
              <BackgroundDescription
                content={acf.blog.background_description}
                relative
              />
            )}
            <Blog
              ids={acf.blog.related}
              fields={blogInfo.get()}
              hideMore
              hideFilters
            />
          </div>
        </section>
      )}
    </Layout>
  )
}

const Thumbnail = styled(Plaatjie)`
  border-radius: 15px;
  overflow: hidden;
  z-index: 1;
  height: 230px;
  display: block !important;
`

const NationContent = styled.div`
  z-index: 2;
`

const Nation = ({ title, path, image }) =>  (
    <div className="col-md-4 mb-5">
      <Thumbnail image={image} alt={title} />
      <NationContent className="text-center mt-n4 position-relative">
      <ButtonAlt to={path} type="next">
          {title}
      </ButtonAlt>
      </NationContent>
    </div>    
)

export default PageTemplate
